import { FC } from 'react';
import styles from './snackbar.module.sass';
import { ISnackbarData } from '../types';
import * as React from 'react';
import { Stack } from 'react-bootstrap';
import { CSSTransition, TransitionGroup } from 'react-transition-group';

export interface SnackbarProps {
    snackbarNotifications: ISnackbarData[],
    handleDeleteSnackbarNotification: (snackbarNotification: ISnackbarData) => void,
    handleClearSnackbarNotifications: () => void
}

export const Snackbar: FC<SnackbarProps> = (props) => {

    const snackbarItem = (snackbarNotification: ISnackbarData) => {

        const canClose = snackbarNotification.canClose ? snackbarNotification : false;

        if (!canClose) {
            setTimeout(() => {
                props.handleDeleteSnackbarNotification(snackbarNotification);
            }, 5000);
        }

        return (
            <TransitionGroup>
                <CSSTransition classNames="fade" timeout={3000} appear enter={true} exit={true}>
                    <div className={`toast ${styles.snackbar} show`}
                         key={`toast-${props.snackbarNotifications.indexOf(snackbarNotification)}`}>
                        <div className="d-flex">
                            <div className="toast-body">
                                {snackbarNotification.text}
                            </div>
                            {snackbarNotification.canClose &&
                                <button type="button" className={`btn-close btn-close-white me-2 m-auto`}
                                        data-bs-dismiss="toast"
                                        aria-label="Close"
                                        onClick={() => props.handleDeleteSnackbarNotification(snackbarNotification)}></button>}
                        </div>
                    </div>
                </CSSTransition>
            </TransitionGroup>
        );
    };

    return (
        <Stack gap={2} className={styles.snackbarWrapper}>
            {props.snackbarNotifications.map(snackbarNotification =>
                snackbarItem(snackbarNotification)
            )}
        </Stack>
    );
};
